import {
    useSyncExternalStore
} from "react";
import {
    AccessibilityInfo,
    Platform
} from "react-native";

type ReduceMotionSubscriptionType = {
    remove: () => void;
};

type ReduceMotionListenerType = () => void;

const REDUCE_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

const reduceMotionListeners = new Set<ReduceMotionListenerType>();

const getInitialReduceMotion = () => {
    if(Platform.OS !== "web" || typeof globalThis.matchMedia !== "function") {
        return false;
    }

    return globalThis.matchMedia(REDUCE_MOTION_QUERY).matches;
};

let reduceMotionSubscription: ReduceMotionSubscriptionType | undefined;

let isReduceMotionEnabledSnapshot = getInitialReduceMotion();

let reduceMotionRequestId = 0;

const updateReduceMotionSnapshot = (isReduceMotionEnabled: boolean) => {
    if(isReduceMotionEnabledSnapshot === isReduceMotionEnabled) {
        return;
    }

    isReduceMotionEnabledSnapshot = isReduceMotionEnabled;

    reduceMotionListeners.forEach((listener) => {
        listener();
    });
};

const onReduceMotionChanged = (isReduceMotionEnabled: boolean) => {
    reduceMotionRequestId += 1;

    updateReduceMotionSnapshot(isReduceMotionEnabled);
};

const requestReduceMotion = async () => {
    reduceMotionRequestId += 1;

    const requestId = reduceMotionRequestId;

    try {
        const isReduceMotionEnabled = await AccessibilityInfo.isReduceMotionEnabled();

        if(requestId === reduceMotionRequestId) {
            updateReduceMotionSnapshot(isReduceMotionEnabled);
        }
    } catch {
        return;
    }
};

const subscribeReduceMotion = (listener: ReduceMotionListenerType) => {
    reduceMotionListeners.add(listener);

    if(reduceMotionListeners.size === 1) {
        reduceMotionSubscription = AccessibilityInfo.addEventListener("reduceMotionChanged", onReduceMotionChanged);

        requestReduceMotion();
    }

    return () => {
        reduceMotionListeners.delete(listener);

        if(!reduceMotionListeners.size) {
            reduceMotionSubscription?.remove();

            reduceMotionSubscription = undefined;
        }
    };
};

const getReduceMotionSnapshot = () => isReduceMotionEnabledSnapshot;

const getReduceMotionServerSnapshot = () => false;

requestReduceMotion();

const useReducedMotion = (): boolean => {
    return useSyncExternalStore(subscribeReduceMotion, getReduceMotionSnapshot, getReduceMotionServerSnapshot);
};
export default useReducedMotion;
